import { Badge } from "@/components/ui/badge";
import { Languages, UserCheck } from "lucide-react";

interface ProfileBadgesProps {
  languages: string[];
  experienceLevel?: string;
}

export const ProfileBadges = ({ languages, experienceLevel }: ProfileBadgesProps) => {
  return (
    <div className="flex flex-wrap gap-2 mb-4">
      {languages.map((lang, index) => (
        <Badge key={index} variant="secondary" className="flex items-center gap-1">
          <Languages className="h-3 w-3" />
          {lang}
        </Badge>
      ))}
      {experienceLevel && (
        <Badge variant="outline" className="flex items-center gap-1">
          <UserCheck className="h-3 w-3" />
          {experienceLevel}
        </Badge>
      )}
    </div>
  );
};